module.exports = {"title":"HTML <u>still</u> ROCKS!","body":"<!--\ntitle: HTML <u>still</u> ROCKS!\n-->\n<p>You can also author content in raw HTML if that's your flavoring. Gatsby handles\nthat just fine.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./html.html
// module id = 544
// module chunks = 0